import { getPageConfigDataByKey, getPageInitDataByKey } from '../index';

export const getBaseIndeedURL = () =>
    getPageConfigDataByKey('baseIndeedUrl', 'https://www.indeed.com');

export const getBaseMsgsUrl = () => {
    const { BASE_URL } = getPageInitDataByKey('msgsClientOptions', { BASE_URL: '' });

    return BASE_URL;
};

export const getResumeURL = () => getPageConfigDataByKey('resumeUrl', getBaseIndeedURL());

export const getRootURL = () => '/';
